module.exports = __webpack_public_path__ + "static/media/ico-swiggle.6be26fe1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ico-swiggle.svg
// module id = 60
// module chunks = 0